webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuetify = __webpack_require__(92);
	
	var _vuetify2 = _interopRequireDefault(_vuetify);
	
	var _vueResource = __webpack_require__(89);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _App = __webpack_require__(64);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _store = __webpack_require__(7);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _routes = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuetify2.default);
	_vue2.default.use(_vueResource2.default);
	
	_vue2.default.http.headers.common['Content-Type'] = 'application/json';
	
	new _vue2.default({
	    router: _routes.router,
	    store: _store2.default,
	    render: function render(h) {
	        return h(_App2.default);
	    }
	}).$mount('#app');

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(52)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(22),
	  /* template */
	  __webpack_require__(84),
	  /* scopeId */
	  "data-v-5d7e02a0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.router = exports.routes = undefined;
	
	var _Home = __webpack_require__(67);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Confirmation = __webpack_require__(65);
	
	var _Confirmation2 = _interopRequireDefault(_Confirmation);
	
	var _Login = __webpack_require__(68);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Payment = __webpack_require__(71);
	
	var _Payment2 = _interopRequireDefault(_Payment);
	
	var _PaymentForm = __webpack_require__(70);
	
	var _PaymentForm2 = _interopRequireDefault(_PaymentForm);
	
	var _Profile = __webpack_require__(72);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _Register = __webpack_require__(73);
	
	var _Register2 = _interopRequireDefault(_Register);
	
	var _Sponsors = __webpack_require__(75);
	
	var _Sponsors2 = _interopRequireDefault(_Sponsors);
	
	var _SponsorsInfo = __webpack_require__(74);
	
	var _SponsorsInfo2 = _interopRequireDefault(_SponsorsInfo);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(90);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _store = __webpack_require__(7);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var routes = exports.routes = [{
	    path: '/',
	    component: _Home2.default,
	    name: 'home'
	}, {
	    path: '/login',
	    component: _Login2.default,
	    name: 'login'
	}, {
	    path: '/logout',
	    name: 'logout',
	    beforeEnter: function beforeEnter(to, from, next) {
	        _store2.default.dispatch('signOut', next);
	    }
	}, {
	    path: '/profile/:uid',
	    component: _Profile2.default,
	    name: 'profile'
	}, {
	    path: '/register',
	    component: _Register2.default,
	    name: 'register'
	}, {
	    path: '/sponsors',
	    component: _Sponsors2.default,
	    children: [{
	        path: '',
	        component: _SponsorsInfo2.default,
	        name: 'sponsors-info'
	    }]
	}, {
	    path: '/payment',
	    component: _Payment2.default,
	    children: [{
	        path: '',
	        component: _PaymentForm2.default,
	        name: 'payment-form'
	    }, {
	        path: 'confirmation',
	        component: _Confirmation2.default,
	        name: 'payment-confirmation'
	    }]
	}, {
	    path: '/*',
	    name: 'notfound',
	    redirect: { name: 'home' }
	}];
	var router = exports.router = new _vueRouter2.default({ routes: routes, mode: 'history' });

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(93);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _authentication = __webpack_require__(16);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	    modules: {
	        auth: _authentication2.default
	    }
	});

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/fish-2.e32cfab.png";

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/fish-3.5b94a2e.png";

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/fish1.7e792aa.png";

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CurrencyValidator = undefined;
	
	var _trunc = __webpack_require__(30);
	
	var _trunc2 = _interopRequireDefault(_trunc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CurrencyValidator = exports.CurrencyValidator = {
	    format: function format(number) {
	        return ((0, _trunc2.default)(number * 100) / 100).toFixed(2);
	    },
	    parse: function parse(newString, oldNumber) {
	        var CleanParse = function CleanParse(value) {
	            return { value: value };
	        };
	        var CurrencyWarning = function CurrencyWarning(warning, value) {
	            return {
	                warning: warning,
	                value: value,
	                attempt: newString
	            };
	        };
	        var NotAValidDollarAmountWarning = function NotAValidDollarAmountWarning(value) {
	            return new CurrencyWarning(newString + ' is not a valid dollar amount', value);
	        };
	        var AutomaticConversionWarning = function AutomaticConversionWarning(value) {
	            return new CurrencyWarning(newString + ' was automatically converted to ' + value, value);
	        };
	
	        var newNumber = Number(newString);
	        var indexOfDot = newString.indexOf('.');
	        var indexOfE = newString.indexOf('e');
	
	        if (isNaN(newNumber)) {
	            if (indexOfDot === -1 && indexOfE > 0 && indexOfE === newString.length - 1 && Number(newString.slice(0, indexOfE)) !== 0) {
	                return new CleanParse(oldNumber);
	            } else {
	                return new NotAValidDollarAmountWarning(oldNumber);
	            }
	        }
	
	        var newCurrencyString = CurrencyValidator.format(newNumber);
	        var newCurrencyNumber = Number(newCurrencyString);
	
	        if (newCurrencyNumber === newNumber) {
	            if (indexOfE !== -1 && indexOfE === newString.length - 2) {
	                return new AutomaticConversionWarning(newNumber);
	            } else {
	                return new CleanParse(newNumber);
	            }
	        } else {
	            return new NotAValidDollarAmountWarning(newNumber > newCurrencyNumber ? newCurrencyNumber : oldNumber);
	        }
	    }
	};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _routes = __webpack_require__(6);
	
	var state = {
	    user: {
	        uid: '0',
	        email: 'hacker@vt.edu',
	        firstName: 'Hack',
	        lastName: 'VT',
	        school: 'Virginia Tech',
	        gender: 'Non-Binary',
	        dietary: 'Bits'
	    },
	    isAuthenticated: false
	};
	
	var mutations = {
	    'AUTH_USER': function AUTH_USER(state, user) {
	        state.user = user;
	        state.isAuthenticated = true;
	    },
	    'UNAUTH_USER': function UNAUTH_USER(state) {
	        state.user = null;
	        state.isAuthenticated = false;
	    }
	};
	
	var actions = {
	    logIn: function logIn(_ref, payload) {
	        var commit = _ref.commit;
	
	
	        var dbUser = state.user;
	        dbUser.uid = state.user.uid;
	        commit('AUTH_USER', dbUser);
	        _routes.router.replace(_routes.router.currentRoute.query.redirect || '/');
	    },
	    signOut: function signOut(_ref2, next) {
	        var commit = _ref2.commit;
	
	
	        commit('UNAUTH_USER');
	        next('/');
	    },
	    setUser: function setUser(_ref3, user) {
	        var commit = _ref3.commit;
	
	        commit('AUTH_USER', user);
	    }
	};
	
	var getters = {
	    user: function user(state) {
	        return state.user;
	    },
	    isAuth: function isAuth(state) {
	        return state.isAuthenticated;
	    }
	};
	
	exports.default = { state: state, mutations: mutations, actions: actions, getters: getters };

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Nav = __webpack_require__(69);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'app',
	    data: function data() {
	        return {
	            itemsGroup: [{ header: 'VTHacks' }, { title: 'Home', href: '/', router: true }, { title: 'Sponsors', href: '/sponsors', router: true }, { title: 'Login/Register', href: '/login', router: true }]
	        };
	    },
	
	    components: {
	        appNav: _Nav2.default
	    },
	    mounted: function mounted() {
	        this.$vuetify.init();
	    }
	};

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _currencyValidator = __webpack_require__(14);
	
	exports.default = {
	    name: 'currency-input',
	    props: {
	        value: {
	            type: Number,
	            default: 0
	        },
	        label: {
	            type: String,
	            default: ''
	        }
	    },
	    mounted: function mounted() {
	        this.formatValue();
	    },
	    methods: {
	        updateValue: function updateValue(value) {
	            var result = _currencyValidator.CurrencyValidator.parse(value, this.value);
	            if (result.warning) {
	                this.$refs.input.value = result.value;
	            }
	            this.$emit('input', result.value);
	        },
	        formatValue: function formatValue() {
	            this.$refs.input.value = _currencyValidator.CurrencyValidator.format(this.value);
	        },
	        selectAll: function selectAll(event) {
	            setTimeout(function () {
	                event.target.select();
	            }, 0);
	        }
	    }
	};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Logo = __webpack_require__(2);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'home',
	    components: {
	        appLogo: _Logo2.default
	    },
	    data: function data() {
	        return {
	            msg: 'VTHACKS'
	        };
	    }
	};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Logo = __webpack_require__(2);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'login',
	    data: function data() {
	        return {
	            title: 'Join the fun to build and innovate',
	            userModel: {
	                email: '',
	                password: ''
	            }
	        };
	    },
	
	    methods: {
	        login: function login() {
	            this.$store.dispatch('logIn', {
	                email: this.userModel.email,
	                password: this.userModel.password
	            });
	        }
	    },
	    components: {
	        appLogo: _Logo2.default
	    }
	};

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'nav',
	    computed: {
	        authenticated: function authenticated() {
	            var authInfo = this.$store.getters.isAuth;
	
	            if (!authInfo) {
	                return [{ text: 'Login/Register', href: '/login', router: true }];
	            } else {
	                var userInfo = this.$store.getters.user;
	                return [{
	                    parent: { text: userInfo.firstname + ' ' + userInfo.lastname, icon: 'account_circle' },
	                    items: [{ text: 'Profile', href: '/profile/' + userInfo.uid, router: true }, { text: 'Logout', href: '/logout', router: true }]
	                }];
	            }
	        }
	    },
	    data: function data() {
	        return {
	            itemsGroup: [{ text: 'Home', href: '/', router: true }, { text: 'Sponsors', href: '/sponsors', router: true }]
	        };
	    },
	
	    watch: {
	        userData: function userData() {
	            this.userInfo = this.$store.getters.isAuth;
	        }
	    }
	};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Logo = __webpack_require__(2);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _CurrencyInput = __webpack_require__(66);
	
	var _CurrencyInput2 = _interopRequireDefault(_CurrencyInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'sponsors-info',
	    data: function data() {
	        return {
	            title: 'VTHacks - Sponsorship Payment',
	            vthacksPay: 'https://vthacks.webscript.io/',
	            paymentData: {
	                company: '',
	                email: '',
	                cardNumber: '',
	                cardExp: '',
	                cardCode: '',
	                amount: 0,
	                paymentFor: ''
	            }
	        };
	    },
	
	    methods: {
	        modal: function modal(id) {
	            this.$vuetify.bus.pub('modal:toggle:' + id);
	        },
	        charge: function charge() {
	            var strAmount = this.paymentData.amount.toString().replace('.', '');
	
	            this.$http.post(this.vthacksPay + 'create', {
	                company: this.paymentData.company,
	                email: this.paymentData.email,
	                cardNumber: this.paymentData.cardNumber,
	                cardExp: this.paymentData.cardExp,
	                cardCode: this.paymentData.cardCode,
	                amount: strAmount,
	                paymentFor: this.paymentData.paymentFor
	            }).then(function (res) {
	                console.log(res);
	            }, function (err) {
	                console.log(err);
	            });
	            this.$router.replace({ name: 'payment-confirmation' });
	            this.paymentData.company = '';
	            this.paymentData.cardNumber = '';
	            this.paymentData.cardExp = '';
	            this.paymentData.cardCode = '';
	            this.paymentData.amount = '';
	            this.paymentData.paymentFor = '';
	        }
	    },
	    components: {
	        appLogo: _Logo2.default,
	        currencyInput: _CurrencyInput2.default
	    }
	};

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'payment'
	};

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'profile',
	    computed: {
	        user: function user() {
	            return this.$store.getters.user;
	        }
	    }
	};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Logo = __webpack_require__(2);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _firebase_config = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'register',
	    data: function data() {
	        return {
	            title: 'Register',
	            genderOptions: [{ 'text': 'Male', 'value': 'male' }, { 'text': 'Female', 'value': 'female' }, { 'text': 'Other', 'value': 'other' }],
	            dietaryOptions: [{ 'text': 'None', 'value': 'none' }, { 'text': 'Fish', 'value': 'fish' }, { 'text': 'Veggie', 'value': 'veggie' }],
	            mlhCodeUrl: 'https://static.mlh.io/docs/mlh-code-of-conduct.pdf',
	            userModel: {
	                firstname: '',
	                lastname: '',
	                password: '',
	                email: '',
	                school: '',
	                gender: '',
	                dietary: '',
	                checkMlh: []
	            },
	            confirmPassword: '',
	            file: '',
	            submitState: false,
	            submitError: ''
	        };
	    },
	
	    computed: {
	        validatePass: function validatePass() {
	            return this.confirmPassword !== this.userModel.password;
	        }
	    },
	    methods: {
	        register: function register(e) {
	            var _this2 = this;
	
	            var email = this.userModel.email;
	            var password = this.userModel.password;
	            var _this = this;
	
	            _firebase_config.firebaseAuth.createUserWithEmailAndPassword(email, password).then(function (currUser) {
	                var user = _firebase_config.firebaseAuth.currentUser;
	                if (user) {
	                    _this2.submitState = true;
	
	                    _firebase_config.database.ref('/users/' + user.uid).set({
	                        firstname: _this2.userModel.firstname,
	                        lastname: _this2.userModel.lastname,
	                        email: _this2.userModel.email,
	                        school: _this2.userModel.school,
	                        gender: _this2.userModel.gender,
	                        dietary: _this2.userModel.dietary,
	                        checkMlh: _this2.userModel.checkMlh[0]
	                    });
	                    _this2.userModel.uid = user.uid;
	                    _this.$store.dispatch('setUser', _this2.userModel);
	                    _this2.fileUpload({ file: _this2.file, user: user.uid });
	                    _this2.$router.replace('/');
	                } else {
	                    return;
	                }
	            }).catch(function (err) {
	                _this2.submitError = err.message;
	                console.log(err);
	                return;
	            });
	        },
	        onFileChange: function onFileChange(e) {
	            this.file = e.target.files[0] || e.dataTransfer.files[0];
	
	            if (!this.file.length) {
	                return;
	            }
	        },
	        fileUpload: function fileUpload(_ref) {
	            var file = _ref.file,
	                user = _ref.user;
	
	            var metadata = {
	                'contentType': file.type
	            };
	
	            _firebase_config.storage.child('resume/' + user + '/' + file.name).put(file, metadata).then(function (snapshot) {
	                console.log('Uploaded', snapshot.totalBytes, 'bytes.');
	                console.log(snapshot.metadata);
	                var url = snapshot.downloadURL;
	                console.log('File available at', url);
	            }).catch(function (error) {
	                console.error('Upload failed:', error);
	            });
	        }
	    },
	    components: {
	        appLogo: _Logo2.default
	    }
	};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Logo = __webpack_require__(2);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'sponsors-info',
	    data: function data() {
	        return {
	            title: 'VTHacks Sponsors 2017'
	        };
	    },
	
	    components: {
	        appLogo: _Logo2.default
	    }
	};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'sponsors'
	};

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/seaweed-left.38c36a1.png";

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/seaweed-right.9b521d7.png";

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/title-card-seaweed-left.5989e5f.png";

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/title-card-seaweed-right.8a60308.png";

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(48)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(17),
	  /* template */
	  __webpack_require__(80),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(47)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(18),
	  /* template */
	  __webpack_require__(79),
	  /* scopeId */
	  "data-v-167c472a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(55)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(19),
	  /* template */
	  __webpack_require__(87),
	  /* scopeId */
	  "data-v-bc360dd8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(53)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(20),
	  /* template */
	  __webpack_require__(85),
	  /* scopeId */
	  "data-v-70ad1058",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(51)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(21),
	  /* template */
	  __webpack_require__(83),
	  /* scopeId */
	  "data-v-4b6a6944",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(49)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(23),
	  /* template */
	  __webpack_require__(81),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(56)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(24),
	  /* template */
	  __webpack_require__(88),
	  /* scopeId */
	  "data-v-de78f780",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(54)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(25),
	  /* template */
	  __webpack_require__(86),
	  /* scopeId */
	  "data-v-a18b9ebe",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(46)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(26),
	  /* template */
	  __webpack_require__(78),
	  /* scopeId */
	  "data-v-15a1fec4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(50)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(27),
	  /* template */
	  __webpack_require__(82),
	  /* scopeId */
	  "data-v-1afe0dd0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(44)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(28),
	  /* template */
	  __webpack_require__(76),
	  /* scopeId */
	  "data-v-0376b3dd",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(45)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(29),
	  /* template */
	  __webpack_require__(77),
	  /* scopeId */
	  "data-v-15341fe4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "clearfix home"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('v-container', {
	    staticClass: "sponsor-info"
	  }, [_c('app-logo'), _vm._v(" "), _c('v-row', [_c('v-col', {
	    attrs: {
	      "mt-5": "",
	      "xs12": "",
	      "sm12": "",
	      "md12": "",
	      "offset-lg4": "",
	      "lg4": ""
	    }
	  }, [_c('h1', [_vm._v(_vm._s(_vm.title))])])], 1), _vm._v(" "), _c('div', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(13)
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(11)
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(12)
	    }
	  })])], 1)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "seaweed-right"
	  }, [_c('img', {
	    staticClass: "right-seaweed",
	    attrs: {
	      "src": __webpack_require__(61)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "seaweed-left"
	  }, [_c('img', {
	    staticClass: "left-seaweed",
	    attrs: {
	      "src": __webpack_require__(60)
	    }
	  })])
	}]}

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('router-view')
	},staticRenderFns: []}

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-container', {
	    staticClass: "profile"
	  }, [_c('v-row', [_c('v-col', {
	    attrs: {
	      "xs12": "",
	      "sm12": "",
	      "offset-md3": "",
	      "md6": "",
	      "offset-lg4": "",
	      "lg4": ""
	    }
	  }, [_c('v-card', [_c('v-card-row', {
	    attrs: {
	      "actions": "",
	      "img": "../../static/milkyway.png",
	      "height": "300px"
	    }
	  }, [_c('v-card-text', {
	    staticClass: "white--text pa-0"
	  }, [_c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
	    staticClass: "mr-3",
	    attrs: {
	      "icon": ""
	    }
	  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-card-row', {
	    staticClass: "pl-5 pt-5",
	    attrs: {
	      "height": "100%"
	    }
	  }, [_c('div', {
	    staticClass: "display-1 pl-5 pt-5"
	  }, [_vm._v(_vm._s(_vm.user.firstname))])])], 1)], 1), _vm._v(" "), _c('v-list', {
	    attrs: {
	      "two-line": ""
	    }
	  }, [_c('v-divider', {
	    attrs: {
	      "inset": ""
	    }
	  }), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', {
	    attrs: {
	      "avatar": ""
	    }
	  }, [_c('v-list-tile-avatar', [_c('v-icon', {
	    staticClass: "indigo--text"
	  }, [_vm._v("mail")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Personal")])], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', {
	    attrs: {
	      "avatar": ""
	    }
	  }, [_c('v-list-tile-avatar'), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("One ( 1 )")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Table Number")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
	    attrs: {
	      "inset": ""
	    }
	  }), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', {
	    attrs: {
	      "avatar": ""
	    }
	  }, [_c('v-list-tile-avatar', [_c('v-icon', {
	    staticClass: "indigo--text"
	  }, [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.user.school))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("School")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._v("\n    PAYMENT DONE\n")])
	},staticRenderFns: []}

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-app', {
	    staticClass: "teal lighten-4",
	    attrs: {
	      "top-navbar": "",
	      "footer": "",
	      "left-fixed-sidebar": ""
	    }
	  }, [_c('header', [_c('app-nav')], 1), _vm._v(" "), _c('main', {
	    staticClass: "clearfix"
	  }, [_c('v-sidebar', {
	    attrs: {
	      "drawer": "",
	      "items": _vm.itemsGroup,
	      "id": "mainsidebar"
	    }
	  }), _vm._v(" "), _c('v-content', [_c('transition', {
	    attrs: {
	      "name": "slide",
	      "mode": "out-in"
	    }
	  }, [_c('router-view')], 1)], 1)], 1), _vm._v(" "), _c('v-footer', [_c('div', [_vm._v(" </> with zZz")])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-navbar', {
	    staticClass: "white"
	  }, [_c('v-navbar-side-icon', {
	    directives: [{
	      name: "sidebar",
	      rawName: "v-sidebar:mainsidebar",
	      arg: "mainsidebar"
	    }],
	    staticClass: "hidden-sm-and-up"
	  }), _vm._v(" "), _c('v-navbar-logo', [_c('h1', {
	    staticClass: "navbar__title"
	  }, [_vm._v("VTHACKS")])]), _vm._v(" "), _c('v-spacer', {
	    staticClass: "hidden-sm-and-down"
	  }), _vm._v(" "), _c('v-navbar-items', {
	    staticClass: "hidden-sm-and-down",
	    attrs: {
	      "items": _vm.itemsGroup
	    }
	  }), _vm._v(" "), _c('v-navbar-items', {
	    staticClass: "hidden-sm-and-down",
	    attrs: {
	      "items": _vm.authenticated
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-container', {
	    staticClass: "register"
	  }, [_c('app-logo'), _vm._v(" "), _c('v-row', [_c('v-col', {
	    attrs: {
	      "xs12": "",
	      "offset-sm2": "",
	      "sm8": "",
	      "offset-md3": "",
	      "md6": "",
	      "offset-lg4": "",
	      "lg4": ""
	    }
	  }, [_c('div', {
	    staticClass: "mb-3"
	  }), _vm._v(" "), _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.register($event)
	      }
	    }
	  }, [_c('v-text-input', {
	    attrs: {
	      "required": "",
	      "name": "firstName",
	      "id": "firstName",
	      "label": "First Name"
	    },
	    model: {
	      value: (_vm.userModel.firstname),
	      callback: function($$v) {
	        _vm.$set(_vm.userModel, "firstname", (typeof $$v === 'string' ? $$v.trim() : $$v))
	      },
	      expression: "userModel.firstname"
	    }
	  }), _vm._v(" "), _c('v-text-input', {
	    attrs: {
	      "required": "",
	      "name": "lastName",
	      "id": "lastName",
	      "label": "Last Name"
	    },
	    model: {
	      value: (_vm.userModel.lastname),
	      callback: function($$v) {
	        _vm.$set(_vm.userModel, "lastname", (typeof $$v === 'string' ? $$v.trim() : $$v))
	      },
	      expression: "userModel.lastname"
	    }
	  }), _vm._v(" "), _c('v-text-input', {
	    attrs: {
	      "required": "",
	      "type": "password",
	      "name": "password",
	      "id": "password",
	      "label": "Password"
	    },
	    model: {
	      value: (_vm.userModel.password),
	      callback: function($$v) {
	        _vm.$set(_vm.userModel, "password", $$v)
	      },
	      expression: "userModel.password"
	    }
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.validatePass),
	      expression: "validatePass"
	    }],
	    staticClass: "error"
	  }, [_vm._v("Passwords don't match.")]), _vm._v(" "), _c('v-text-input', {
	    attrs: {
	      "required": "",
	      "type": "password",
	      "name": "password",
	      "id": "validatePassword",
	      "label": "Confirm Password"
	    },
	    model: {
	      value: (_vm.confirmPassword),
	      callback: function($$v) {
	        _vm.confirmPassword = $$v
	      },
	      expression: "confirmPassword"
	    }
	  }), _vm._v(" "), _c('v-text-input', {
	    attrs: {
	      "required": "",
	      "id": "email",
	      "name": "email",
	      "type": "email",
	      "label": "Email"
	    },
	    model: {
	      value: (_vm.userModel.email),
	      callback: function($$v) {
	        _vm.$set(_vm.userModel, "email", (typeof $$v === 'string' ? $$v.trim() : $$v))
	      },
	      expression: "userModel.email"
	    }
	  }), _vm._v(" "), _c('v-text-input', {
	    attrs: {
	      "required": "",
	      "id": "school",
	      "name": "school",
	      "label": "School"
	    },
	    model: {
	      value: (_vm.userModel.school),
	      callback: function($$v) {
	        _vm.$set(_vm.userModel, "school", (typeof $$v === 'string' ? $$v.trim() : $$v))
	      },
	      expression: "userModel.school"
	    }
	  }), _vm._v(" "), _c('v-select', {
	    attrs: {
	      "required": "",
	      "options": _vm.genderOptions,
	      "id": "gender",
	      "label": "Gender",
	      "name": "gender"
	    },
	    model: {
	      value: (_vm.userModel.gender),
	      callback: function($$v) {
	        _vm.$set(_vm.userModel, "gender", $$v)
	      },
	      expression: "userModel.gender"
	    }
	  }), _vm._v(" "), _c('v-select', {
	    attrs: {
	      "options": _vm.dietaryOptions,
	      "id": "dietary",
	      "label": "Dietary",
	      "name": "dietary"
	    },
	    model: {
	      value: (_vm.userModel.dietary),
	      callback: function($$v) {
	        _vm.$set(_vm.userModel, "dietary", $$v)
	      },
	      expression: "userModel.dietary"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "file-input"
	  }, [_c('input', {
	    attrs: {
	      "type": "file"
	    },
	    on: {
	      "change": _vm.onFileChange
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "mlh-check-box"
	  }, [_c('v-checkbox', {
	    attrs: {
	      "required": "",
	      "value-v": "yes",
	      "id": "mlhCode",
	      "name": "mlhCode",
	      "label": "I Agree to MLH Code of Conduct"
	    },
	    model: {
	      value: (_vm.userModel.checkMlh),
	      callback: function($$v) {
	        _vm.$set(_vm.userModel, "checkMlh", $$v)
	      },
	      expression: "userModel.checkMlh"
	    }
	  })], 1), _vm._v(" "), _c('a', {
	    attrs: {
	      "id": "mlhCodeHref",
	      "href": _vm.mlhCodeUrl,
	      "target": "_blank"
	    }
	  }, [_vm._v("(link)")]), _vm._v(" "), _c('div', [_vm._v("\n                     \n                ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "registerBtn"
	    }
	  }, [_c('v-btn', {
	    staticClass: "vt-submit-btn",
	    attrs: {
	      "ripple": {
	        class: 'teal--text'
	      },
	      "type": "submit",
	      "round": true,
	      "loading": _vm.submitState
	    },
	    on: {
	      "click": _vm.register
	    }
	  }, [_vm._v("\n                        Submit\n                    ")]), _vm._v(" "), _c('div', {
	    staticClass: "error"
	  }, [_vm._v(_vm._s(_vm.submitError))])], 1)], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-container', {
	    staticClass: "register"
	  }, [_c('app-logo'), _vm._v(" "), _c('v-row', [_c('v-col', {
	    attrs: {
	      "xs12": "",
	      "offset-sm2": "",
	      "sm8": "",
	      "offset-md3": "",
	      "md6": "",
	      "offset-lg4": "",
	      "lg4": ""
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n            "), _c('form', [_c('v-text-input', {
	    attrs: {
	      "id": "email",
	      "name": "email",
	      "type": "email",
	      "label": "Email"
	    },
	    model: {
	      value: (_vm.userModel.email),
	      callback: function($$v) {
	        _vm.$set(_vm.userModel, "email", $$v)
	      },
	      expression: "userModel.email"
	    }
	  }), _vm._v(" "), _c('v-text-input', {
	    attrs: {
	      "id": "password",
	      "name": "password",
	      "type": "password",
	      "label": "Password"
	    },
	    model: {
	      value: (_vm.userModel.password),
	      callback: function($$v) {
	        _vm.$set(_vm.userModel, "password", $$v)
	      },
	      expression: "userModel.password"
	    }
	  }), _vm._v(" "), _c('div', [_vm._v("\n                     \n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "text-xs-center text-md-center"
	  }, [_c('div', {
	    attrs: {
	      "id": "loginBtn"
	    }
	  }, [_c('v-btn', {
	    staticClass: "vt-submit-btn",
	    attrs: {
	      "ripple": {
	        class: 'teal--text'
	      },
	      "type": "submit",
	      "round": ""
	    },
	    nativeOn: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.login($event)
	      }
	    }
	  }, [_vm._v("\n                            Login\n                        ")])], 1), _vm._v(" "), _c('router-link', {
	    staticStyle: {
	      "text-decoration": "none"
	    },
	    attrs: {
	      "to": "/register"
	    }
	  }, [_c('v-btn', {
	    staticClass: "vt-submit-btn",
	    attrs: {
	      "ripple": {
	        class: 'teal--text'
	      },
	      "round": ""
	    }
	  }, [_vm._v("\n                            Register\n                        ")])], 1)], 1)], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "logo-container"
	  }, [_c('svg', {
	    attrs: {
	      "viewBox": "114 105 968 778",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "xmlns:xlink": "http://www.w3.org/1999/xlink"
	    }
	  }, [_c('polygon', {
	    attrs: {
	      "id": "Path-6",
	      "stroke": "#979797",
	      "stroke-width": "1",
	      "fill": "#FFFFFF",
	      "fill-rule": "evenodd",
	      "points": "601.439453 881.119141 114.996094 105.890625 1081.02344 107.375"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "logo",
	    attrs: {
	      "d": "M1024.89062,153.914063 L614.148438,380.488281 L614,791.59375 L614.148438,821 L1024.89062,153.914063 Z M1008.5,131.990947 L601.484375,361 L183.117188,130.09375 L1008.5,131.990947 Z M589.488281,821.699219 L588.613083,381 L176.785156,158.660156 L589.488281,821.699219 Z",
	      "id": "Combined-Shape",
	      "stroke": "#979797",
	      "stroke-width": "1",
	      "fill": "#B2DFDB",
	      "fill-rule": "evenodd"
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "clearfix home"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('v-container', {
	    staticClass: "home-content",
	    attrs: {
	      "fluid": ""
	    }
	  }, [_c('app-logo'), _vm._v(" "), _c('v-row', [_c('v-col', {
	    attrs: {
	      "xs12": "",
	      "sm12": "",
	      "md12": "",
	      "lg12": ""
	    }
	  }, [_c('div', {
	    staticClass: "home-title"
	  }, [_c('p', {
	    attrs: {
	      "id": "vthacksTitle"
	    }
	  }, [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "vthacksNum"
	    }
	  }, [_vm._v("IV")])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "vthacksDate"
	    }
	  }, [_vm._v("\n                    February 12th, 2017\n                ")]), _vm._v(" "), _c('router-link', {
	    staticStyle: {
	      "text-decoration": "none"
	    },
	    attrs: {
	      "to": "/register"
	    }
	  }, [_c('v-btn', {
	    staticClass: "vt-submit-btn",
	    attrs: {
	      "ripple": {
	        class: 'teal--text'
	      },
	      "round": ""
	    }
	  }, [_vm._v("Register")])], 1)], 1)], 1)], 1)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "seaweed-right"
	  }, [_c('img', {
	    staticClass: "right-seaweed",
	    attrs: {
	      "src": __webpack_require__(63)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "seaweed-left"
	  }, [_c('img', {
	    staticClass: "left-seaweed",
	    attrs: {
	      "src": __webpack_require__(62)
	    }
	  })])
	}]}

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('router-view')
	},staticRenderFns: []}

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.label) ? _c('label', [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v("\n    $\n    "), _c('input', {
	    ref: "input",
	    domProps: {
	      "value": _vm.value
	    },
	    on: {
	      "input": function($event) {
	        return _vm.updateValue($event.target.value)
	      },
	      "focus": _vm.selectAll,
	      "blur": _vm.formatValue
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-container', {
	    staticClass: "sponsor-info"
	  }, [_c('v-row', [_c('v-col', {
	    attrs: {
	      "mt-5": "",
	      "xs12": "",
	      "sm12": "",
	      "md12": "",
	      "offset-lg4": "",
	      "lg4": ""
	    }
	  }, [_c('app-logo'), _vm._v(" "), _c('h1', [_vm._v("Thank You, Sponsors!")]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('v-btn', {
	    directives: [{
	      name: "modal",
	      rawName: "v-modal:modal",
	      arg: "modal"
	    }],
	    staticClass: "teal darken-1 white--text"
	  }, [_vm._v("\n                Payment\n            ")]), _vm._v(" "), _c('v-modal', {
	    attrs: {
	      "id": "modal"
	    }
	  }, [_c('v-card', [_c('form', {
	    staticClass: "payment"
	  }, [_c('v-card-text', [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-text-input', {
	    attrs: {
	      "name": "company",
	      "id": "company",
	      "label": "Company"
	    },
	    model: {
	      value: (_vm.paymentData.company),
	      callback: function($$v) {
	        _vm.$set(_vm.paymentData, "company", $$v)
	      },
	      expression: "paymentData.company"
	    }
	  }), _vm._v(" "), _c('v-text-input', {
	    attrs: {
	      "name": "email",
	      "id": "email",
	      "label": "Payer's Email"
	    },
	    model: {
	      value: (_vm.paymentData.email),
	      callback: function($$v) {
	        _vm.$set(_vm.paymentData, "email", $$v)
	      },
	      expression: "paymentData.email"
	    }
	  }), _vm._v(" "), _c('v-text-input', {
	    attrs: {
	      "name": "card-number",
	      "id": "cardNumber",
	      "label": "Card Number"
	    },
	    model: {
	      value: (_vm.paymentData.cardNumber),
	      callback: function($$v) {
	        _vm.$set(_vm.paymentData, "cardNumber", $$v)
	      },
	      expression: "paymentData.cardNumber"
	    }
	  }), _vm._v(" "), _c('v-text-input', {
	    attrs: {
	      "name": "card-exp",
	      "id": "cardExp",
	      "label": "Expiration Date (MM/YY)"
	    },
	    model: {
	      value: (_vm.paymentData.cardExp),
	      callback: function($$v) {
	        _vm.$set(_vm.paymentData, "cardExp", $$v)
	      },
	      expression: "paymentData.cardExp"
	    }
	  }), _vm._v(" "), _c('v-text-input', {
	    attrs: {
	      "name": "card-code",
	      "id": "cardCode",
	      "label": "CVC"
	    },
	    model: {
	      value: (_vm.paymentData.cardCode),
	      callback: function($$v) {
	        _vm.$set(_vm.paymentData, "cardCode", $$v)
	      },
	      expression: "paymentData.cardCode"
	    }
	  }), _vm._v(" "), _c('currency-input', {
	    attrs: {
	      "label": "Amount"
	    },
	    model: {
	      value: (_vm.paymentData.amount),
	      callback: function($$v) {
	        _vm.$set(_vm.paymentData, "amount", $$v)
	      },
	      expression: "paymentData.amount"
	    }
	  }), _vm._v(" "), _c('v-text-input', {
	    attrs: {
	      "name": "paymentFor",
	      "id": "paymentFor",
	      "label": "Payment For"
	    },
	    model: {
	      value: (_vm.paymentData.paymentFor),
	      callback: function($$v) {
	        _vm.$set(_vm.paymentData, "paymentFor", _vm._n($$v))
	      },
	      expression: "paymentData.paymentFor"
	    }
	  })], 1), _vm._v(" "), _c('v-card-row', {
	    attrs: {
	      "actions": ""
	    }
	  }, [_c('v-btn', {
	    attrs: {
	      "id": "modal"
	    },
	    nativeOn: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.modal('modal')
	      }
	    }
	  }, [_vm._v("\n                                Cancel\n                            ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
	    staticClass: "teal darken-1 white--text",
	    nativeOn: {
	      "click": function($event) {
	        return _vm.charge($event)
	      }
	    }
	  }, [_vm._v("\n                                Submit\n                            ")])], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(13)
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(11)
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(12)
	    }
	  })])], 1)
	},staticRenderFns: []}

/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.0a94e25c03f71f388153.js